import React, {useCallback, useEffect, useState} from "react";
import { useHistory } from "react-router-dom";
import { Avatar, Box,  Grid } 
from "@mui/material"; 
//import ShareIcon from "@mui/icons-material/Share";
//import SystemUpdateAltIcon from "@mui/icons-material/SystemUpdateAlt";
//import ProfilePicture from "./profile_picture";
import DetailText from "./detail_text";
//import EndCard from "./end_card";
//import Cards from "./cards";
//import HealthProfileButton from "./health_profile_button";
//import BackButton from "./back_button";
//import ProfessionalImage from "./professional_image";
import AccessLocalStorage from "../../../services/localStorage";
import { getApiUrl } from "../../../services/api_service";
import { paddingbox, paddingboxeven, rcolor } from "../../../style2";
//import Height from "@mui/icons-material/Height";

function Dashboard({
  profile_image,
  detail_text,
  share_icons,
  cards,
  end_card,
  health_profile_button,
  back_button,
  professional_profile_image,
  fullWidth = false
}) {
  const ls = new AccessLocalStorage();
  const history = useHistory();
  const [error, setError] = useState("");
  const [diagnosis, setDiagnosis] = useState(null);
  const [gmfcLevel, setGMFCLevel] = useState(null);
  const handleOnClick = useCallback(
    () => history.push("/health_profile"),
    [history]
  );

  useEffect(() => {
    const authTokens = localStorage.getItem("authTokens");
    let token;

    if (authTokens) {
      const parsedAuthTokens = JSON.parse(authTokens);
      token = parsedAuthTokens?.accessToken;
    }
    if (!token) {
      return;
    }
    
    fetch(
      `${getApiUrl()}${process.env.REACT_APP_GET_PROFILE}/diagnosis/${ls.getCurrentPatientId()}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((response) => {
        if(response.status === 200){
          response.json().then(data => {
            setDiagnosis(data.diagnosis);
          setGMFCLevel(data.gmfcLevel);
          });
        }else{
          response.json().then(data => {
            setError(data.error);
          }).catch(err => {
            setError("Unable to fetch latest diagnosis and GMFCLevel.");
            console.log(err);
          })
        }
      })
      .catch((err) => {
         setError("Unable to fetch latest diagnosis and GMFCLevel."); 
         console.log(err);
        })
      .finally(() => { });
  }, []);

  return (
    <Box  sx={{ paddingTop: "15px", ...(fullWidth ? paddingboxeven : paddingbox) }}>
      <Grid container xs={12} alignItems='center'>
        <Grid item xs={1} >
          <Avatar sx={{ width: "60px", height: "60px", backgroundColor: rcolor }} /></Grid>
        <Grid item xs={11}>
          {detail_text && <DetailText share_icons={share_icons} gmfcLevel={gmfcLevel} diagnosis={diagnosis} />}
        </Grid>
      </Grid>
      <Box sx={{ padding: "10px 1rem 10px 1rem", borderBottom: "2px solid #fff" }} />
    </Box>
  );
}

export default Dashboard;
